import type { GameId } from '@chessmate/protocol';

/**
 * Lesson concepts that belong to ONE game. The Learn screen shows a game's lessons only while that game is visible in this build for this
 * person (in the edition, in the build's game list, and `prod`, or `beta` for someone who opted in), so a beta game's lessons do not appear
 * before the game does. A concept that is not listed here (the chess and checkers lessons) is always shown.
 *
 * Blackjack, Poker and the four-player Mahjong table have NO lessons and so no entry: their lesson text would ship in every build, which the
 * web-only and adult-only guarantees forbid (`lessons-keep-the-other-games-out` in packages/lessons).
 */
export const CONCEPT_GAME: Readonly<Record<string, GameId>> = {
  backgammon: 'backgammon',
  bridge: 'bridge',
  whist: 'whist',
  hearts: 'hearts',
  'crazy-eights': 'crazy-eights',
  rummy: 'rummy',
  pirate: 'pirate',
  'colour-dash': 'colour-dash',
  'mahjong-solitaire': 'mahjong-solitaire',
};

/** Is this concept's lesson group to be shown, given the games that are visible right now? */
export function conceptVisible(concept: string, visibleGames: readonly GameId[]): boolean {
  const game = CONCEPT_GAME[concept];
  return game === undefined || visibleGames.includes(game);
}
